// Date formatting for Indian format (DD/MM/YYYY)
export const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

// Currency formatting for Indian Rupees
export const formatCurrency = (amount) => {
  if (amount == null || isNaN(amount)) return '₹0';
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
};

// Convert DD/MM/YYYY to ISO string for backend
export const parseIndianDate = (dateString) => {
  if (!dateString) return '';
  const [day, month, year] = dateString.split('/');
  return new Date(`${year}-${month}-${day}`).toISOString();
};

// Get date input value (YYYY-MM-DD) from ISO string
export const getDateInputValue = (isoString) => {
  if (!isoString) return '';
  return isoString.split('T')[0];
};

// Calculate days until date
export const daysUntil = (dateString) => {
  if (!dateString) return null;
  const targetDate = new Date(dateString);
  const today = new Date();
  const diffTime = targetDate - today;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
};

// Indian mobile number validation — accepts a raw string OR pre-stripped
// digits. Returns { ok, digits, error } where digits is normalised.
export function validateIndianMobile(raw) {
  if (raw === null || raw === undefined) return { ok: false, digits: '', error: 'Mobile number is required' };
  let digits = String(raw).replace(/\D/g, '');
  if (digits.length === 12 && digits.startsWith('91')) digits = digits.slice(2); // drop pasted country code
  if (digits.length !== 10) return { ok: false, digits, error: 'Mobile number must be exactly 10 digits' };
  if (!/^[6-9]/.test(digits)) return { ok: false, digits, error: 'Indian mobile numbers start with 6, 7, 8 or 9' };
  return { ok: true, digits, error: null };
}
